import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisApi = ApiDefinition['/ai/document-analysis/{documentId}']['POST'];
type Input = ThisApi['body'] & ThisApi['params'];
type Output = ThisApi['response'];

const generateDocumentAnalysisForDocument = async ({ documentId, documentRequestUserFileId }: Input): Promise<Output> => {
  const response = await noodleApiClient.post(`/ai/document-analysis/${documentId}`, { documentRequestUserFileId });
  return response.data;
};

export default generateDocumentAnalysisForDocument;
